import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import cityProfileImage from '../../../assests/Exotic/ex/1.jpg';
import cityProfileImage1 from '../../../assests/Exotic/ex/2.jpg';
import cityProfileImage2 from '../../../assests/Exotic/ex/3.jpg';
import cityProfileImage3 from '../../../assests/Exotic/ex/4.jpg';
import cityProfileImage4 from '../../../assests/Exotic/ex/5.jpg';
import cityProfileImage5 from '../../../assests/Exotic/ex/6.jpg';
import cityProfileImage13 from '../../../assests/Exotic/ex/7.jpg';
import cityProfileImage14 from '../../../assests/Exotic/ex/8.jpg';
import cityProfileImage15 from '../../../assests/Exotic/ex/9.jpg';
import cityProfileImage16 from '../../../assests/Exotic/ex/10.jpg';
import cityProfileImage17 from '../../../assests/Exotic/ex/11.jpg';

import cityProfileImage6 from '../../../assests/Exotic/1.jpg';
import cityProfileImage7 from '../../../assests/Exotic/2.jpg';
import cityProfileImage8 from '../../../assests/Exotic/3.jpg';
import cityProfileImage9 from '../../../assests/Exotic/4.jpg';
import cityProfileImage10 from '../../../assests/Exotic/5.jpg';
import cityProfileImage11 from '../../../assests/Exotic/6.jpg';
import cityProfileImage12 from '../../../assests/Exotic/7.jpg';


const photos = [
  { src: cityProfileImage, width: 3, height: 4 },
  { src: cityProfileImage1, width: 3, height: 4 },
  { src: cityProfileImage2, width: 3, height: 4 },
  { src: cityProfileImage3, width: 3, height: 4 } , 
  { src: cityProfileImage4, width: 3, height: 4 },
  { src: cityProfileImage5, width: 3, height: 4 }, 
  
  { src: cityProfileImage13, width: 3, height: 4 }, 
  { src: cityProfileImage14, width: 3, height: 4 }, 
  { src: cityProfileImage15, width: 3, height: 4 }, 
  { src: cityProfileImage16, width: 3, height: 4 }, 
  { src: cityProfileImage17, width: 3, height: 4 }, 
  { src: cityProfileImage6, width: 4, height: 3 }, 
  { src: cityProfileImage7, width: 4, height: 3 }, 
  { src: cityProfileImage8, width: 4, height: 3 }, 
  { src: cityProfileImage9, width: 4, height: 3 }, 
  { src: cityProfileImage10, width: 4, height: 3 }, 
  { src: cityProfileImage11, width: 4, height: 3 }, 
  { src: cityProfileImage12, width: 4, height: 3 }, 
 

];

function Slider({ onImageSelect }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [photoIndex]);

  
  const handleImageLoad = () => {
    setLoaded(true);
  };

  const openLightbox = () => {
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const handleThumbnailClick = (index) => {
    setPhotoIndex(index);
    onImageSelect(photos[index].src); // ارسال الصورة المختارة
  };

  return (
    <div className="photo-gallery  container">
      <div className="main-image d-flex justify-content-center">
        <img
          src={photos[photoIndex].src}
          alt="Main"
          onLoad={handleImageLoad}
          className={loaded ? 'loaded' : ''}
          onClick={openLightbox}
        />
      </div>

      <div className="thumbnail-gallery">
        {photos.map((photo, index) => (
          <div key={index} className="thumbnail-item">
            <img
              src={photo.src}
              alt={`Thumbnail ${index + 1}`}
              onClick={() => handleThumbnailClick(index)}
              className={photoIndex === index ? 'active-thumbnail' : ''}
            />
          </div>
        ))}
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={photos[photoIndex].src}
          nextSrc={photos[(photoIndex + 1) % photos.length].src}
          prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].src}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % photos.length)
          }
        />
      )}
    </div>
  );
}
export default Slider;
